import React from "react"
// import { AllReportsContext } from "../contextProviders/allReportsContext"
import {PageHomeDisplay} from './pageHome_display'

export function PageHome(props){

  return (
      <PageHomeDisplay />
  )
} 